import {VALIDATE_CONFIG} from "../defaults.js";

export const validate = (node,config)=>{
    jQuery(node).validate(
        Object.assign(config || {}
        , VALIDATE_CONFIG)
    );
 }